module.exports = __webpack_public_path__ + "static/media/profile-inverse.afe4b1e5.svg";